export const applicationConstants = {
	SELECTED_COMPANY_CHANGED: 'SELECTED_COMPANY_CHANGED',
	SET_AVAILABLE_STORES: 'SET_AVAILABLE_STORES',
	SET_AVAILABLE_COMPANIES: 'SET_AVAILABLE_COMPANIES',
	TOGGLE_NAVIGATION_BAR : 'TOGGLE_NAVIGATION_BAR',
	SET_SELECTED_STORE_FOR_REVIEW_LEADERBOARD: 'SET_SELECTED_STORE_FOR_REVIEW_LEADERBOARD',
	SET_REVIEW_LEADERBOARD_OPTIN_STATUS: 'SET_REVIEW_LEADERBOARD_OPTIN_STATUS',
	DEFAULT_STORE: { value: "-1", id:-1 }
}	